import React from "react";
import Sidebar from "../components/layout/SideBarComponent";
import AppHeader from "../components/layout/AppHeaderComponent";

import { Layout } from "antd";
import ReminderTable from "../components/reminder/ReminderComponent";
const { Content } = Layout;

export default function Reminder() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <AppHeader />
      <Sidebar />

      <Content
        style={{
          marginTop: 64,
          marginLeft: 200,
          padding: 24,
          background: "#f0f2f5",
        }}
      >
        <ReminderTable />
      </Content>
    </Layout>
  );
}
